import { Injectable } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { COOKIE_CATEGORIES } from '@monsido/ng2/core/constants/cookie-categories.constant';

@Injectable({
    providedIn: 'root',
})
export class CookieCategoriesLocalizeService {
    public readonly [COOKIE_CATEGORIES.analytics]: string = '';
    public readonly [COOKIE_CATEGORIES.basic]: string = '';
    public readonly [COOKIE_CATEGORIES.essential]: string = '';
    public readonly [COOKIE_CATEGORIES.marketing]: string = '';
    public readonly [COOKIE_CATEGORIES.personalisation]: string = '';

    constructor (private translateService: TranslateService) {
        this[COOKIE_CATEGORIES.analytics] = this.translateService.getString('Statistics');
        this[COOKIE_CATEGORIES.basic] = this.translateService.getString('Basic');
        this[COOKIE_CATEGORIES.essential] = this.translateService.getString('Essential');
        this[COOKIE_CATEGORIES.marketing] = this.translateService.getString('Marketing');
        this[COOKIE_CATEGORIES.personalisation] = this.translateService.getString('Preferences');
    }
}
